// extracted by mini-css-extract-plugin
module.exports = {"title":"Article_title__RZd4n","section":"Article_section__t_Mvb","error":"Article_error__DrmuA","pending":"Article_pending__DD6G3"};